import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import Alert from '@mui/material/Alert';
import { Button, Divider, TextField, Grid, Typography, Box, CircularProgress } from "@mui/material"

import { getProductrawStruct, setData } from './ProductrawStruct'
import { updateTextValue, handleSubmit, updateValue, updateSelectedValue } from '../../core/js/FormUtils'
import { createAPI, updateAPI, getAPI, updateEditableAPI } from './ProductrawAPI';
import { CoreContext } from "../../core/context/CoreContext";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { validMobileNumberEntry, validNameEntry, validEmailEntry } from '../../core/js/FormValidation';

import { getPathVariable } from '../../core/js/UrlUtils';
import { useSearchParams } from "react-router-dom";
import RadioForBoolean from '../../core/form/RadioForBoolean';
import MyDate from '../../core/components/MyDate';
import { useDispatch, useSelector } from 'react-redux';
import { updateProductrawObj, addProductrawObj, setShowEditForProductraw } from 'store/slice/PharmaSlice';
import { setApiInProgress } from 'store/slice/HeaderSlice';



export default function ProductrawEditFormImpl() {
    const dispatch = useDispatch();
    const { setNotification, lastURL } = React.useContext(CoreContext);
    const [formValues, setFormValues] = useState(getProductrawStruct);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('Something went wrong');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const { productrawDashboard } = useSelector((state) => state.pharmaslice);
    const [productrawId, setProductrawId] = useState(productrawDashboard.selectedId);
    const { businessid } = useSelector((state) => state.headerslice.userprofileInfo);
    const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);

    const { productList } = useSelector((state) => state.pharmaslice);
    const handleDynamicSelectedValueForproductid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'productname', e.target.value == 0 ? 'Select Item' : productList.find(obj => obj.id === e.target.value).title);
    }
    const { rawmaterialList } = useSelector((state) => state.pharmaslice);
    const handleDynamicSelectedValueForrmid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'rmname', e.target.value == 0 ? 'Select Item' : rawmaterialList.find(obj => obj.id === e.target.value).title);
    }
    const { rmunitList } = useSelector((state) => state.pharmaslice);
    const handleDynamicSelectedValueForunitid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'unitname', e.target.value == 0 ? 'Select Item' : rmunitList.find(obj => obj.id === e.target.value).title);
    }

    const { apiInProgress } = useSelector((state) => state.headerslice)
    useEffect(() => {
    }, [apiInProgress])

    useEffect(() => {
        if (productrawId !== -1) {
            if (dataLoaded) return;
            getAPI(productrawId, loadForm);
        }
        else {
            // formValues.<<CONTEXT>>.value=searchParams.get('<<CONTEXT>>');
            setDataLoaded(true);
        }

        setFormValues({
            ...formValues,
            ['businessid']: {
                ...formValues['businessid'],
                value: businessid
            },
            ['productid']: {
                ...formValues['productid'],
                value: productObj.id
            },
            ['productname']: {
                ...formValues['productname'],
                value: productObj.title
            }
        })
    }, []);

    const loadForm = (data) => {
        setData(data, formValues, setFormValues);
        setDataLoaded(true);
    }
    const handleRadioChange = (name, value) => {
        setShowError(false);
        console.log(value + " == " + getRadioAPIvalue(value))
        updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const getRadioValue = (value) => {
        if (value)
            return "yes"
        else
            return "no"
    }
    const getRadioAPIvalue = (value) => {
        if (value === "yes")
            return true
        else
            return false
    }
    const handleTextChange = (e) => {
        setShowError(false);
        updateTextValue(formValues, setFormValues, e);
    }

    const handleNameChange = (e) => {
        setShowError(false);

        if (validNameEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleMobileChange = (e) => {
        setShowError(false);

        if (validMobileNumberEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleEmailidChange = (e) => {
        setShowError(false);

        if (validEmailEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }

    const createSuccessCallback = (obj) => {
        dispatch(setApiInProgress(false));
        dispatch(addProductrawObj(obj));
        setNotification('Record has been cretaed successfully !!!');
        dispatch(setShowEditForProductraw(false));
    }
    const updateSuccessCallback = (obj) => {
        dispatch(setApiInProgress(false));
        dispatch(updateProductrawObj(obj));
        setNotification('Record with id[' + productrawId + '] has been updated successfully !!!');
        dispatch(setShowEditForProductraw(false));

    }
    const failuerCallback = (errorMsg) => {
        dispatch(setApiInProgress(false));
        setErrorMsg(errorMsg);
        setShowError(true);
    }
    const onSubmit = (e) => {
        handleSubmit(e, productrawId, formValues, setFormValues, createSuccessCallback, updateSuccessCallback, failuerCallback, createAPI, updateAPI);
    }
    const setDate = (fieldName, value) => {
        var date = new Date(value);

        const day = date.getDate();
        const dayStr = day < 10 ? '0' + day : day.toString();

        const month = date.getMonth() + 1;
        const monthStr = month < 10 ? '0' + month : month.toString();
        var dateStr = date.getFullYear() + "-" + monthStr + "-" + dayStr + "T00:00:00.000Z";
        updateValue(formValues, setFormValues, fieldName, dateStr);
    }
    return (
        <form noValidate onSubmit={onSubmit} >
            <Grid container direction="column" padding={.25}>
                {showError ? <Alert severity="error">{errorMsg}</Alert> : ''}
                <Box sx={{ flexGrow: 1 }}>
                    <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: 440 }}>
                        <Grid container direction="column" padding={.25}>
                            <Grid item>
                                <Typography variant='h4'>{productrawId === -1 ? 'Add Raw Material of Product @'+ productObj.title : 'Edit Raw Material of Product @ '+productObj.title}</Typography>
                                <Divider />
                            </Grid>
                            <Grid height='25px' ></Grid>
                            {dataLoaded ?
                                <Grid container display="flex" spacing={2} direction="row" justifyContent="space-between" alignItems="center">



                                    <Grid item lg={8} xs={12}>
                                        <FormControl sx={{ width: '100%' }} size="Normal">
                                            <InputLabel id="demo-simple-select-autowidth-label">Select Raw Material</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-autowidth-label"
                                                id="demo-simple-select-autowidth"
                                                label={formValues.rmid.label}
                                                name={formValues.rmid.name}
                                                value={formValues.rmid.value}
                                                onChange={handleDynamicSelectedValueForrmid}

                                                error={formValues.rmid.error}
                                                helpertext={formValues.rmid.error && formValues.rmid.errorMessage}
                                            >
                                                <MenuItem key={0} value="0">Select Item</MenuItem>
                                                {
                                                    rawmaterialList && rawmaterialList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                        <TextField size="Normal"
                                            placeholder={formValues.rmname.placeholder}
                                            required={formValues.rmname.required}
                                            label={formValues.rmname.label}
                                            name={formValues.rmname.name}
                                            value={formValues.rmname.value}
                                            onChange={handleTextChange}
                                            error={formValues.rmname.error}
                                            helpertext={formValues.rmname.error && formValues.rmname.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    <Grid item lg={2} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.qty.placeholder}
                                            required={formValues.qty.required}
                                            label={formValues.qty.label}
                                            name={formValues.qty.name}
                                            value={formValues.qty.value}
                                            onChange={handleTextChange}
                                            error={formValues.qty.error}
                                            helpertext={formValues.qty.error && formValues.qty.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    <Grid item lg={2} xs={12}>
                                        <FormControl sx={{ width: '100%' }} size="Normal">
                                            <InputLabel id="demo-simple-select-autowidth-label">Select Unit</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-autowidth-label"
                                                id="demo-simple-select-autowidth"
                                                label={formValues.unitid.label}
                                                name={formValues.unitid.name}
                                                value={formValues.unitid.value}
                                                onChange={handleDynamicSelectedValueForunitid}

                                                error={formValues.unitid.error}
                                                helpertext={formValues.unitid.error && formValues.unitid.errorMessage}
                                            >
                                                <MenuItem key={0} value="0">Select Item</MenuItem>
                                                {
                                                    rmunitList && rmunitList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                        <TextField size="Normal"
                                            placeholder={formValues.unitname.placeholder}
                                            required={formValues.unitname.required}
                                            label={formValues.unitname.label}
                                            name={formValues.unitname.name}
                                            value={formValues.unitname.value}
                                            onChange={handleTextChange}
                                            error={formValues.unitname.error}
                                            helpertext={formValues.unitname.error && formValues.unitname.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.businessid.placeholder}
                                            required={formValues.businessid.required}
                                            label={formValues.businessid.label}
                                            name={formValues.businessid.name}
                                            value={formValues.businessid.value}
                                            onChange={handleTextChange}
                                            error={formValues.businessid.error}
                                            helpertext={formValues.businessid.error && formValues.businessid.errorMessage}
                                            sx={{ width: '100%', display: 'none' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                <FormControl sx={{  width:'100%'}} size="Normal">
                                    <InputLabel id="demo-simple-select-autowidth-label">{formValues.productid.label}</InputLabel>
                                    <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            label={formValues.productid.label}
                                            name={formValues.productid.name}
                                            value={formValues.productid.value}
                                            onChange={handleDynamicSelectedValueForproductid}
                                            
                                            error={formValues.productid.error}
                                            helpertext={formValues.productid.error && formValues.productid.errorMessage}
                                            >
                                            <MenuItem key={0} value="0">Select Item</MenuItem>
                                            {
                                                productList && productList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>) 
                                            }
                                        </Select>
                                </FormControl> 
                            </Grid>                        
                            <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                <TextField size="Normal"
                                    placeholder={formValues.productname.placeholder}
                                    required={formValues.productname.required}
                                    label={formValues.productname.label}
                                    name={formValues.productname.name}
                                    value={formValues.productname.value}
                                    onChange={handleTextChange}
                                    error={formValues.productname.error}
                                    helpertext={formValues.productname.error && formValues.productname.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                </Grid>

                                : <></>}
                        </Grid>
                    </Grid>
                </Box>
                <Grid height='25px' ></Grid>
                <Grid padding={1}>
                    <Divider />
                </Grid>
                <Grid container direction="row" justifyContent="flex-end"  >
                    {apiInProgress ? <CircularProgress /> :
                        <>
                            <Button variant="outlined" type="submit" >{productrawId === -1 ? 'Add' : 'Save'}</Button>&nbsp;&nbsp;&nbsp;
                            <Button variant="outlined" onClick={() => { dispatch(setShowEditForProductraw(false)); }}>Close</Button>
                        </>
                    }
                </Grid>
            </Grid>
            
        </form>
    );
};